/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService
 */
import * as References from './BreezeEngineConversationsService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#listConversations
 */
export const LIST_CONVERSATIONS_QUERY_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_listConversations';
export const LIST_CONVERSATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_CONVERSATIONS_QUERY_FIELD_NAME,
  args: ['agentId', 'limit', 'offset', 'offsetUpdatedAt', 'scope', 'collectionId', 'excludeSubAgentConversations', 'excludeTriggeredTasks', 'sortBy'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.listConversationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#getConversation
 */
export const GET_CONVERSATION_QUERY_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_getConversation';
export const GET_CONVERSATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONVERSATION_QUERY_FIELD_NAME,
  args: ['conversationId', 'pageLength', 'offset', 'sortDirection'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getConversationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#getConversationsByIds
 */
export const GET_CONVERSATIONS_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_getConversationsByIds';
export const GET_CONVERSATIONS_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONVERSATIONS_BY_IDS_QUERY_FIELD_NAME,
  args: ['conversationIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getConversationsByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#deleteConversation
 */
export const DELETE_CONVERSATION_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_deleteConversation';
export const DELETE_CONVERSATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_CONVERSATION_MUTATION_FIELD_NAME,
  args: ['conversationId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.deleteConversationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#renameConversation
 */
export const RENAME_CONVERSATION_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_renameConversation';
export const RENAME_CONVERSATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RENAME_CONVERSATION_MUTATION_FIELD_NAME,
  args: ['conversationId', 'title', 'updatedAt'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.renameConversationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#shareConversation
 */
export const SHARE_CONVERSATION_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_shareConversation';
export const SHARE_CONVERSATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SHARE_CONVERSATION_MUTATION_FIELD_NAME,
  args: ['conversationId', 'sharedWithUserId', 'permission'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.shareConversationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#revokeConversationShare
 */
export const REVOKE_CONVERSATION_SHARE_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_revokeConversationShare';
export const REVOKE_CONVERSATION_SHARE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REVOKE_CONVERSATION_SHARE_MUTATION_FIELD_NAME,
  args: ['conversationId', 'sharedWithUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.revokeConversationShareRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#getConversationShares
 */
export const GET_CONVERSATION_SHARES_QUERY_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_getConversationShares';
export const GET_CONVERSATION_SHARES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONVERSATION_SHARES_QUERY_FIELD_NAME,
  args: ['conversationId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getConversationSharesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#createConversation
 */
export const CREATE_CONVERSATION_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_createConversation';
export const CREATE_CONVERSATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_CONVERSATION_MUTATION_FIELD_NAME,
  args: ['agentId', 'previousConversationId', 'collectionId', 'conversationMetadata', 'initialMessageContent', 'ablyEnabled', 'configVersion', 'createdAt', 'title', 'copyFilesystem'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.createConversationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#getMessage
 */
export const GET_MESSAGE_QUERY_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_getMessage';
export const GET_MESSAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MESSAGE_QUERY_FIELD_NAME,
  args: ['conversationId', 'messageId'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getMessageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#getMessagePayload
 */
export const GET_MESSAGE_PAYLOAD_QUERY_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_getMessagePayload';
export const GET_MESSAGE_PAYLOAD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MESSAGE_PAYLOAD_QUERY_FIELD_NAME,
  args: ['turnId'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getMessagePayloadRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#updateCollectionId
 */
export const UPDATE_COLLECTION_ID_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_updateCollectionId';
export const UPDATE_COLLECTION_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_COLLECTION_ID_MUTATION_FIELD_NAME,
  args: ['conversationId', 'collectionId'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.updateCollectionIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#appendTranscript
 */
export const APPEND_TRANSCRIPT_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_appendTranscript';
export const APPEND_TRANSCRIPT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: APPEND_TRANSCRIPT_MUTATION_FIELD_NAME,
  args: ['conversationId', 'contentBlocks', 'role', 'serializedFullTranscript'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.appendTranscriptRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#forkConversation
 */
export const FORK_CONVERSATION_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_forkConversation';
export const FORK_CONVERSATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: FORK_CONVERSATION_MUTATION_FIELD_NAME,
  args: ['conversationId', 'forkAfterTurnId', 'copyFilesystem'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.forkConversationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#searchConversations
 */
export const SEARCH_CONVERSATIONS_QUERY_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_searchConversations';
export const SEARCH_CONVERSATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_CONVERSATIONS_QUERY_FIELD_NAME,
  args: ['query', 'limit', 'collectionId'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.searchConversationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService#markConversationRead
 */
export const MARK_CONVERSATION_READ_MUTATION_FIELD_NAME = 'com_hubspot_breeze_engine_rpc_BreezeEngineConversationsService_markConversationRead';
export const MARK_CONVERSATION_READ_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MARK_CONVERSATION_READ_MUTATION_FIELD_NAME,
  args: ['conversationId'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.markConversationReadRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});